import { Link } from "react-router-dom";

export function NotFound() {
  return (
    <main className="flex h-full flex-col items-center justify-center gap-4 p-8 text-center">
      <h1 className="text-4xl font-semibold">404</h1>
      <p className="text-muted-foreground">That route does not exist.</p>
      <Link to="/" className="text-primary underline-offset-4 hover:underline">
        Back to Mission Control
      </Link>
    </main>
  );
}
